export default __webpack_public_path__ + "51d408b86d2c0c4d05fd45b8fe08ba95.svg";